import c1 from "./cloud/c1.json";
import c2 from "./cloud/c2.json";
import c3 from "./cloud/c3.json";
import c4 from "./cloud/c4.json";

import d1 from "./dataCenter/d1.json";
import d2 from "./dataCenter/d2.json";

import n1 from "./netWork/n1.json";
import n2 from "./netWork/n2.json";
import n3 from "./netWork/n3.json";
import n4 from "./netWork/n4.json";

// 网络安全
export let dataCenter = [d1, d2];
// 企业网络
export let network = [n1, n2, n3, n4];
// 无线方案
export let cloud = [c1, c2, c3, c4];
